module.exports = __webpack_public_path__ + "static/2-947303bf240047e3c49bcc10f039f624.jpg";